import type { ExpertTrialBalanceHeaderKpis } from '../types/expertTrialBalanceHeaderKpis'
import type { ExpertTrialBalanceReport } from '../types/expertTrialBalanceReport'

export const selectTrialBalanceHeaderKpis = (
  report: ExpertTrialBalanceReport | undefined,
): ExpertTrialBalanceHeaderKpis | null => {
  if (!report?.result || report.header.length === 0) {
    return null
  }

  const currentPeriodKey = report.header[0]?.key
  const previousPeriodKey = report.header[1]?.key

  if (currentPeriodKey === undefined) {
    return null
  }

  const current = report.result[currentPeriodKey]

  if (current === undefined) {
    return null
  }

  const previous =
    previousPeriodKey !== undefined && report.result[previousPeriodKey] !== undefined
      ? report.result[previousPeriodKey]
      : null

  return { current, previous }
}
